import Clock from "./SVG/clock.svg?react";

const ClockIcon = () => {
  return <Clock />;
};

export default ClockIcon;
